import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Loading from '../components/Loading'
import { useAuth } from './AuthContext'

const encodeNext = (location) => encodeURIComponent(`${location.pathname}${location.search}`)

export const safeNextPath = (value) => {
    if (!value) return '/resumen'
    try {
        const path = decodeURIComponent(value)
        return path.startsWith('/') && !path.startsWith('//') ? path : '/resumen'
    } catch (error) {
        return '/resumen'
    }
}

export const ProtectedRoute = ({ children, permiso, role, fallback = '/resumen' }) => {
    const { user, isReady, canAccess, hasRole } = useAuth()
    const location = useLocation()

    if (!isReady) return <Loading show />
    if (!user) return <Navigate to={`/login?url=${encodeNext(location)}`} replace />
    if (role && !hasRole(role) && !hasRole('ROLE_ADMIN')) {
        return <Navigate to={fallback} replace />
    }
    if (permiso && !canAccess(permiso)) {
        return <Navigate to={fallback} replace />
    }
    return children
}

export const GuestRoute = ({ children }) => {
    const { user, isReady } = useAuth()
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const next = params.get('url')

    if (!isReady) return <Loading show />
    if (user) {
        return <Navigate to={safeNextPath(next)} replace />
    }
    return children
}
